var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.200195 12.6512C0.200195 14.1191 0.464242 15.5251 0.946586 16.8251L12.2002 17.8686L23.4538 16.8251C23.9361 15.5251 24.2002 14.1191 24.2002 12.6512C24.2002 11.1834 23.9361 9.77731 23.4538 8.47732L12.2002 7.43384L0.946586 8.47732C0.464242 9.77731 0.200195 11.1834 0.200195 12.6512H0.200195Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4535 8.47723C21.758 3.90767 17.3595 0.651123 12.1999 0.651123C7.04032 0.651123 2.6418 3.90767 0.946289 8.47723H23.4535Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.946289 16.825C2.6418 21.3945 7.04032 24.6511 12.1999 24.6511C17.3595 24.6511 21.758 21.3945 23.4535 16.825H0.946289Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/Spain.a7a4302285cfa1dcadd80e82cd5a4356.svg";
export { ForwardRef as ReactComponent };